import React from 'react';
import '../styles/Information.css';

function Information() {
  return (
    <div className="information-page">
      <div className="information-content">
        <p className="info-text">Berlin based music photographer.</p>
        <p className="info-text">Available worldwide.</p>
        <p className="info-text">
          For all inquiries, greetings and commissions,<br />
          reach out to me at <a href="mailto:hi@lunasahin.com">hi@lunasahin.com</a>
        </p>
      </div>
    </div>
  );
}

export default Information; 